import { EmptyStateCategories } from '@fhs-legacy/frontend/src/components/store-locator-empty-states/types';
import { OrderLocatorTab } from '@fhs-legacy/frontend/src/utils/launchdarkly/variations';

function tabCaresAboutAuthStatus(tab: OrderLocatorTab): boolean {
  return tab === OrderLocatorTab.FAVORITE || tab === OrderLocatorTab.RECENT;
}

function tabCaresAboutLocationStatus(tab: OrderLocatorTab): boolean {
  return tab === OrderLocatorTab.NEARBY;
}

/**
 * Logic for prioritization & determination of the empty state category for a given tab.
 * Priority Levels:
 *   1. An error occurred
 *   2. Unauthenticated
 *   3. Location Permissions Not Granted
 *   4. No Stores Available
 */
export function determineEmptyStateCategory({
  tab,
  isAuthenticated,
  locationPermissionsGranted,
  currentTabError,
  coordinatesAvailable,
}: {
  tab: OrderLocatorTab;
  isAuthenticated: boolean;
  locationPermissionsGranted: boolean;
  currentTabError: boolean;
  coordinatesAvailable?: boolean;
}): EmptyStateCategories {
  if (currentTabError) {
    return EmptyStateCategories.ERROR;
  }

  if (tabCaresAboutAuthStatus(tab) && !isAuthenticated) {
    return EmptyStateCategories.NO_AUTH;
  }

  if (
    tabCaresAboutLocationStatus(tab) &&
    // if we have manual coords, we don't want the empty state to be no location
    !coordinatesAvailable &&
    !locationPermissionsGranted
  ) {
    return EmptyStateCategories.NO_LOCATION;
  }

  return EmptyStateCategories.NO_STORES;
}
